import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "reply", "onReplyClick", "onClick", "side"];
import React from 'react';
import { Text } from '@carnica/ui-kit';
import { cnBem, getMessageText } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnReply = cnBem('reply', styles);
export var Reply = function Reply(props) {
  var _getMessageText;
  var className = props.className,
    reply = props.reply,
    onReplyClick = props.onReplyClick,
    onClick = props.onClick,
    side = props.side,
    otherProps = _objectWithoutProperties(props, _excluded);
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 || onClick(e);
    onReplyClick === null || onReplyClick === void 0 || onReplyClick(e);
  };
  var author = reply.author,
    message = reply.message;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnReply({
      side: side
    }, [className]),
    onClick: handleClick
  }, otherProps), (author === null || author === void 0 ? void 0 : author.name) && /*#__PURE__*/React.createElement(Text, {
    className: cnReply('name'),
    color: "primary-invert",
    variant: "body-accent-small"
  }, author.name), /*#__PURE__*/React.createElement(Text, {
    className: cnReply('text'),
    color: "primary-invert",
    variant: "body-small"
  }, (_getMessageText = getMessageText(message)) === null || _getMessageText === void 0 ? void 0 : _getMessageText.replace(/<[^>]*>?/gm, ' ')));
};